import Vue from 'vue';
import Vuex from 'vuex';
import login from '@/store/login';
import applicant from '@/store/applicant';
// import occupation from '@/store/occupation';
import user from '@/store/user';
import searchTemplate from '@/store/searchTemplate';
import filterSearch from '@/store/filterSearch';
import field from '@/store/field';
import messageTemplates from '@/store/messageTemplates';
import individual_contact from '@/store/individual_contact';
import flash from '@/store/flash';
import jd from '@/store/jd';
import profileJd from '@/store/profileJd';
import aiMatching from '@/store/aiMatching';

Vue.use(Vuex);

// applicant.js's per-field mutations (memo/status/bookmark) only update its own
// `applicants` list. Both the AI Matching list (aiMatching's `aiMatchedSeekers`) and the
// top-left profile panel (applicant.js's own `profile`, mounted for every profile modal,
// AI mode included) keep separate copies of the same jobseeker, so an edit on one side
// never appeared on the others until a reload. Mirror the relevant field(s) across via a
// single subscriber instead of touching every component that commits these mutations.
const SEEKER_FIELD_SYNC = {
  mutateApplicantsAfterMemo: a => ({ memo: a.memo }),
  mutateApplicantsAfterStatus: a => ({ status: a.status, new_status: a.new_status }),
  mutateApplicantsAfterFav: a => ({ isFavorite: a.isFavorite }),
};

const syncSeekerCopies = (store) => {
  store.subscribe((mutation, state) => {
    const getFields = SEEKER_FIELD_SYNC[mutation.type];
    if (!getFields || !mutation.payload || mutation.payload.id === undefined) return;
    const fields = getFields(mutation.payload);
    store.commit('syncAiMatchedSeekerFields', { id: mutation.payload.id, fields });
    if (state.applicant.profile && state.applicant.profile.id === mutation.payload.id) {
      store.commit('setProfile', { ...state.applicant.profile, ...fields });
    }
  });
};

export default new Vuex.Store({
  modules: {
    auth: login,
    applicant,
    // occupation,
    jd,
    profileJd,
    aiMatching,
    user,
    filterSearch,
    field,
    searchTemplate,
    messageTemplates,
    individual_contact,
    flash
  },
  plugins: [syncSeekerCopies],
});
